import { AxiosResponse } from 'axios';
import { appContextGet, appContextPost } from './httpCommon/appAxios.service';
import { ON_FARM_INVENTORY_TRANSACTION_ENDPOINTS, ON_FARM_INVENTORY_TRANSACTION_HISTORY_ENDPOINTS } from '../constants/apiEndpoints';
import { InventoryTransaction } from '../types/interfaces/transaction.interfaces';

export const getOnFarmInventoryTransactions = (query?: {}): Promise<AxiosResponse<InventoryTransaction[], any>> => {
  return appContextGet(ON_FARM_INVENTORY_TRANSACTION_ENDPOINTS.GET, query);
};

export const getOnFarmInventoryTransactionById = (id: number, query?: {}): Promise<AxiosResponse<InventoryTransaction, any>> => {
  return appContextGet(ON_FARM_INVENTORY_TRANSACTION_ENDPOINTS.GET_ + id, query);
};

export const getOnFarmInventoryTransactionsOdata = (query?: {}): Promise<AxiosResponse<InventoryTransaction[], any>> => {
  return appContextGet(ON_FARM_INVENTORY_TRANSACTION_ENDPOINTS.ODATA, query);
};

export const downloadOnFarmInventoryTransactionReport = (payload?: {}, query?: {}): Promise<AxiosResponse<any, any>> => {
  return appContextPost(ON_FARM_INVENTORY_TRANSACTION_HISTORY_ENDPOINTS.EXPORT, payload, query, {
    responseType: 'blob',
  });
};
